import React from 'react';
// import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import image from '../../media/vitara.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const About = () => {

    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (

        <div className='about-section' id="about-section">

            <Container>
                <Typography variant="h4" gutterBottom>
                    About Us
                </Typography>
                <div className='about-card'>
                    <div className="image-container">
                        <img src={image} alt="Image of Vitara" width="500" />
                    </div>
                    <div className="text-container">
                        <Typography variant="body1" gutterBottom>
                            <p>Drive Plus Incorporated is a Barbadian based company that provides information services. Established by a young entrepreneur, who has been in the driving tuition industry for almost a decade, Drive Plus Incorporated is the first of its kind and an innovative means of facilitating safe and correct road use.</p>
                        </Typography>
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <CardContent>

                                <Typography paragraph>
                                    Drive Plus Incorporated was created as a solution to two problems: unsafe driving and insufficient teachings.
                                    Unfortunately, because a backlog of national driving tests should always be avoided, testing officers have limited time to conduct driving tests.
                                    Students are then disadvantaged because they are not tested on important roads, roundabouts and intersections. Moreover, some instructors fail to adequately educate their students.
                                    This then manifests into licensed drivers who lack knowledge on how to correctly use these areas, resulting in unsafe driving.
                                    As such, Drive Plus Incorporated was created to distribute platforms and simulations that informs the general public on how to traverse the roads in Barbados safely.
                                </Typography>
                                <Typography paragraph>
                                    Drive Plus Incorporated’s first initiative is a mobile app that provides informative content to be used along-side current driving knowledge or as a supplement to bridge one’s knowledge gap.
                                    As Drive Plus Incorporated continues to build, it will distribute more apps, simulations and services to accommodate the needs of Barbadians and to ensure road users safety.
                                </Typography>

                            </CardContent>
                        </Collapse>
                        Read {!expanded ? 'More' : 'Less'}
                        <ExpandMore
                            expand={expanded}
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more"
                        >

                            <ExpandMoreIcon />
                        </ExpandMore>
                    </div>

                </div>
            </Container>
        </div>
    )
}

export default About